import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function UpgradePrompt({
  requiredPlan = 'pro',
  feature = '',
  compact = false,
}) {
  const navigate = useNavigate();

  const plans = {
    pro:   { name: 'Pro',   price: '₹999/month',   color: 'var(--accent)' },
    elite: { name: 'Elite', price: '₹1,999/month', color: '#d4a017' },
  };

  const plan = plans[requiredPlan] || plans.pro;

  if (compact) {
    return (
      <div
        onClick={() => navigate('/pricing')}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 6,
          padding: '4px 12px',
          background: 'var(--accent-subtle)',
          border: '1px solid var(--accent)',
          borderRadius: '100px',
          cursor: 'pointer',
          fontSize: 12,
          fontWeight: 700,
          color: 'var(--accent)',
        }}
      >
        🔒 {plan.name} Feature
      </div>
    );
  }

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '40px 24px',
      textAlign: 'center',
      background: 'var(--bg-card)',
      border: '1px solid var(--border)',
      borderRadius: 16,
      gap: 16,
    }}>
      <div style={{ fontSize: 40 }}>🔒</div>
      <h3 style={{ fontSize: 20, fontWeight: 800, color: 'var(--text-primary)', margin: 0 }}>
        {plan.name} Feature
      </h3>
      <p style={{ fontSize: 14, color: 'var(--text-secondary)', maxWidth: 300, lineHeight: 1.6, margin: 0 }}>
        {feature || `Yeh feature ${plan.name} plan mein available hai.`}
      </p>
      <div style={{ fontSize: 22, fontWeight: 800, color: plan.color }}>
        {plan.price}
      </div>
      <button
        onClick={() => navigate('/pricing')}
        style={{
          padding: '12px 32px',
          background: plan.color,
          color: '#000',
          border: 'none',
          borderRadius: 10,
          fontSize: 15,
          fontWeight: 800,
          cursor: 'pointer',
        }}
      >
        Upgrade to {plan.name} →
      </button>
      <p style={{ fontSize: 12, color: 'var(--text-muted)', margin: 0 }}>
        7-day free trial • Cancel anytime
      </p>
    </div>
  );
}
